import { Star } from "lucide-react";

const RatingStars = ({ value = 4 }) => {
  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={16}
          className={
            i < value
              ? "text-primaryColor fill-primaryColor"
              : "text-gray-300 fill-gray-300"
          }
        />
      ))}
    </div>
  );
};

export default RatingStars;
